import { Client } from '@/types/client';
import { 
  Users, 
  AlertTriangle, 
  CheckCircle2, 
  Clock,
  Building2 
} from 'lucide-react';

interface DashboardStatsProps {
  clients: Client[];
}

export function DashboardStats({ clients }: DashboardStatsProps) {
  const totalClients = clients.length;
  const overdueCount = clients.filter(c => 
    c.basStatus === 'Overdue' || 
    c.basReturn === 'Overdue' || 
    c.bookkeepingStatus === 'Overdue'
  ).length;
  const completedThisMonth = clients.filter(c => 
    c.basStatus === 'Completed' && 
    c.bookkeepingStatus === 'Completed'
  ).length;
  const pendingCount = clients.filter(c => 
    c.basStatus === 'Pending' || 
    c.basStatus === 'In Progress'
  ).length;

  const stats = [
    {
      label: 'Total Clients',
      value: totalClients,
      icon: Users,
      color: 'text-primary',
      bg: 'bg-primary/10',
    },
    {
      label: 'Overdue Tasks',
      value: overdueCount,
      icon: AlertTriangle,
      color: 'text-destructive',
      bg: 'bg-destructive/10',
    },
    {
      label: 'Completed',
      value: completedThisMonth,
      icon: CheckCircle2,
      color: 'text-success',
      bg: 'bg-success/10',
    },
    {
      label: 'Pending',
      value: pendingCount,
      icon: Clock,
      color: 'text-warning',
      bg: 'bg-warning/10',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map((stat, index) => (
        <div 
          key={stat.label}
          className="bg-card rounded-xl border p-5 shadow-sm hover:shadow-md transition-shadow animate-fade-in"
          style={{ animationDelay: `${index * 100}ms` }}
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-muted-foreground">{stat.label}</p>
              <p className="text-3xl font-bold mt-1">{stat.value}</p>
            </div>
            <div className={`h-12 w-12 rounded-lg ${stat.bg} flex items-center justify-center`}>
              <stat.icon className={`h-6 w-6 ${stat.color}`} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
